import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { AddressPickerComponent } from '../../../../../../../shared/components/address-picker/address-picker.component';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import dayjs from 'dayjs';
import { Job } from '../../../../../../../shared/Jobbing/models/Job';
import { ToasterService } from '../../../../../../../shared/toaster/toaster.service';
import { JobbingService } from '../../../../../../../shared/Jobbing/jobbing.service';

@Component({
  selector: 'app-from-location-form',
  standalone: true,
  imports: [AddressPickerComponent, ReactiveFormsModule],
  templateUrl: './from-location-form.component.html',
  styleUrl: './from-location-form.component.scss'
})
export class FromLocationFormComponent implements OnInit {
  @Input()
  formGroup!: FormGroup;

  @Input()
  resetEmitter!: EventEmitter<boolean>;

  constructor(private fb: FormBuilder, private toasterService: ToasterService, private jobbingService: JobbingService) { }

  ngOnInit() {
    this.resetEmitter.subscribe(() => {
      this.formGroup.get('jobFrom')?.patchValue({
        onSite: false,
      });
    });
    this.initializeForm();
  }

  initializeForm() {
    this.formGroup.addControl('jobFrom', this.fb.group({
      onSite: this.fb.control(false),
      contact: this.fb.group({
        name: this.fb.control(''),
        phone: this.fb.control(''),
        email: this.fb.control('', [Validators.email]),
      }),
      addressSelection: this.fb.group({}),
      preciseLocationOptions: this.fb.group({})
    }));

  }

  getFormGroup() {
    if (!this.formGroup.get('jobFrom')) {
      this.initializeForm();
    }
    return this.formGroup.get('jobFrom') as FormGroup;
  }
}
